import { BackgroundColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { ignoreRTL } from '@picsart/design-system/foundation/styleHelpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      marginBottom: Spacings.s64,
      '&.bg-accented': {
        backgroundColor: BackgroundColors.base,
      },

      '&.image-uploader': {
        position: 'relative',
        paddingBottom: Spacings.s0,
        background: 'inherit',

        '&.bg-accented': {
          '&.original': {
            backgroundImage: `linear-gradient(${BackgroundColors.base} calc(100% - 150px), transparent calc(100% - 150px))`,
            backgroundColor: 'transparent',
          },
          '&.recent': {
            backgroundColor: BackgroundColors.base,
          },
        },

        [mediaQuery(1023)]: {
          marginBottom: Spacings.s40,
        },
      },

      [mediaQuery(1365)]: {
        marginBottom: Spacings.s40,
      },
    },
    imageFromTop: {
      display: 'none',
      [mediaQuery(1023)]: {
        [ignoreRTL]: {
          display: 'block',
          position: 'absolute',
          width: '100%',
        },
      },
    },
    wrapper: {
      '&.image-uploader.original': {
        paddingBottom: Spacings.s0,
      },
    },
    grid: {
      display: 'grid',
      gridTemplateRows: '1fr',

      '&.original': {
        columnGap: Spacings.s72,
        rowGap: Spacings.s24,
        gridTemplateColumns: '7fr 5fr',
        gridTemplateAreas: "'content image' 'action image'",

        '&.has-second-description': {
          gridTemplateAreas: "'content image' 'action image' 'second-desc image'",
        },

        [mediaQuery(1365)]: {
          columnGap: Spacings.s56,
        },

        [mediaQuery(1023)]: {
          gridTemplateColumns: '1fr',
          gridTemplateAreas: "'image' 'content' 'action'",
          '&.has-second-description': {
            gridTemplateAreas: "'image' 'content' 'action' 'second-desc'",
          },
        },
      },

      '&.recent': {
        columnGap: Spacings.s72,
        rowGap: Spacings.s40,
        gridTemplateColumns: '5fr 6fr',
        gridTemplateAreas: "'image content' 'image action'",

        '&.has-second-description': {
          gridTemplateAreas: "'image content' 'image action' 'image second-desc'",
        },

        [mediaQuery(1023)]: {
          gridTemplateColumns: '1fr',
          gridTemplateAreas: "'image' 'content' 'action'",

          '&.has-second-description': {
            gridTemplateAreas: "'image' 'content' 'action' 'second-desc'",
          },
        },
      },
    },
    column: {
      minWidth: Spacings.s0,

      '&.image': {
        gridArea: 'image',
        minHeight: 244,
        width: '100%',
        margin: [Spacings.s0, 'auto'],

        [mediaQuery(1023)]: {
          maxWidth: 456,
        },
      },
      '&.content': {
        display: 'flex',
        justifyContent: 'center',
        gridArea: 'content',
        width: '100%',
      },
      '&.action': {
        display: 'flex',
        justifyContent: 'flex-start',
        gridArea: 'action',
        width: '100%',

        [mediaQuery(1023)]: {
          justifyContent: 'center',
        },
      },
      '&.second-description': {
        display: 'flex',
        justifyContent: 'left',
        gridArea: 'second-desc',
        width: '100%',

        [mediaQuery(1023)]: {
          justifyContent: 'center',
        },
      },

      '&.recent': {
        textAlign: 'center',
        justifyContent: 'center',
      },
    },
    secondDesc: {
      width: '100%',
      textAlign: 'left',
      fontSize: FontSizes.s14,
      lineHeight: LineHeights.l20,

      '&.original': {
        color: TextColors.tint1,
      },
      '&.recent': {
        color: TextColors.base,
      },

      [mediaQuery(1023)]: {
        textAlign: 'center',
      },
    },

    // SKELETON
    contentFallback: {
      flexDirection: 'column',

      '& > .title': {
        marginBottom: Spacings.s24,
        width: '100%',
        height: 140,
      },
      '& > .desc': {
        width: '100%',
        height: 64,
      },
    },
    actionFallback: {
      maxWidth: 282,
      height: 348,

      '&.recent': {
        margin: [Spacings.s0, 'auto'],
      },
    },
  }),
  {
    name: 'hero-banner',
  },
);

export default useStyles;
